import {zodResolver} from "@hookform/resolvers/zod";
import {useForm} from "react-hook-form";
import {z} from "zod";

export const twilioConnectSchema = z.object({
  accountSID: z.string().min(1, "Account SID is required"),
  authToken: z.string().min(1, "Auth Token is required"),
});

export type TwilioConnectSchema = z.infer<typeof twilioConnectSchema>;

export const useTwilioConnectForm = () => {
  const form = useForm<TwilioConnectSchema>({
    mode: "all",
    resolver: zodResolver(twilioConnectSchema),
    defaultValues: {
      accountSID: "",
      authToken: "",
    },
  });

  return {form};
};
